import React from "react";

import Services from "../../../components/ServicesImgText";

import elevator from "../../../images/services/ServicesPage/elevator1.png";
const index = () => {
  return (
    <div>
      <Services
        title=">Home Elevator/lift"
        heading="Home Elevator/lift"
        text="It is now very easy to take the elderly, sick people or women and children in the house and bring them back to the roof or upstairs of the house easily and safely. Our partner GSM Elevator Company is ready to meet your need at the most reasonable cost. More than twenty years of experience in elevator and elevator system installation, it will provide this facility at your home in a highly professional and experienced manner.

        Also install automatic elevator lift for easy and convenient access to the upper floor for the elderly, children and women of the house. Low budget but with high quality and confidence.
        The interior and exterior of the constructed structure is also facilitated to look beautiful and attractive. It consists of different packages according to your budget."
        Image={elevator}
      />
    </div>
  );
};

export default index;
